module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-content col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box-pc-create",
    class: [_vm.lstData.length === 0 ? '' : 'render-list']
  }, [(_vm.lstData.length === 0) ? _c('div', [_c('div', {
    staticClass: "item-pc-title"
  }, [_vm._v("CỘNG ĐỒNG CỦA TÔI")]), _vm._m(1), _c('div', {
    staticClass: "item-pc-bottom"
  }, [_c('span', [_vm._v("Bạn đã sẵn sàng để tạo 1 cộng đồng cho riêng mình? ")]), _c('span', [_vm._v("OBee sẽ giúp bạn")]), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/general_step"
    }
  }, [_vm._v("Tạo cộng đồng ngay!")])], 1)]) : _c('div', [_c('div', {
    staticClass: "item-pc-title"
  }, [_vm._v("CỘNG ĐỒNG CỦA TÔI")]), _c('router-link', {
    staticClass: "button-plus",
    attrs: {
      "to": "/general_step"
    }
  }, [_vm._v("+ Thêm mới cộng đồng")]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "item-pc-list"
  }, [_vm._l((_vm.lstData), function(itemPC, index) {
    return _c('div', [_c('PCItem', {
      attrs: {
        "item": itemPC,
        "obj_id": itemPC.id
      }
    }), _c('div', {
      staticClass: "clearfix"
    })], 1)
  }), _c('div', {
    staticClass: "clearfix"
  })], 2)], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_header"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Tổng quan")]), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-pc-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pc/bg_myPC.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac50838","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PC/index.vue
// module id = 1614
// module chunks = 0